import { OnInit,Inject, Output, EventEmitter } from '@angular/core';
import { FileUpload } from './file-upload'
import { DOCUMENT } from "@angular/platform-browser";
import { PayeeApi, StorageApi } from '../../sdk/services';
import { GlobalEventsManager } from '../../../events-manager.component'

// Abstract Class
export abstract class FormPage extends FileUpload implements OnInit {
  public details;

  public valid: boolean = true;
  public saved: boolean = true;

  @Output() next: EventEmitter<string> = new EventEmitter<string>();
  @Output() back: EventEmitter<string> = new EventEmitter<string>();

  constructor(
        details,
        userApi: PayeeApi,
        storageApi: StorageApi,
        eventsManager: GlobalEventsManager
  ) {
    super(userApi, storageApi, eventsManager);
    this.details = details;
  }

  // INITIALISATION

  abstract ngOnInit() : void; 
  /* { 
    this.valid = true;

    this.populateFormData();

    this.addEventListeners();

  } */

  abstract populateFormData() : void;

  // For vendor custom-select to work with Angular, need to listen for changes and
  // manually assign the chosen value to the model
  // ADD IF COMPONENT CONTAINS SELECT
  abstract addEventListeners() : void;

  // VALIDATION

  abstract validate() : boolean;
  /* {

    this.submit.nativeElement.click();
    this.valid = true;

    // Add all required validation
    
    return this.valid;
  } */

  
  // Save form page
  abstract save(submit?: boolean) : Promise<Object>[] 
  
  /* {
     
    // Make sure form is in good order to be sent to back end
    // e.g. date, if need to convert name to id, etc.
  
    // return a promise for the api call
    e.g. 
    let that = this;
    return new Promise(function(resolve, reject) {
      that.userApi.getDetails(that.id).subscribe(
        (savedDraft: PayeeDetail) => {
          that.userApi.updateDetails(that.id, that.details).subscribe(
            res => {
              that.saved = true;
              if (!submit) {
                that.eventsManager.savedPopUp();
              }
              resolve(res);
            },
            err => reject(err)
          );
        },
        err => {
          that.userApi.createDetails(that.id, that.details).subscribe(
            res => {
              that.saved = true;
              if (!submit) {
                that.eventsManager.savedPopUp();
              }
              resolve(res);
            },
            err => reject(err)
          );
        }
      );
    });
  } */

  scrollToError(){


    // let elements = document.getElementsByClassName('msg-error') as HTMLCollectionOf<HTMLObjectElement>;
    // console.log("FormPageComponent - validate: elements");
    // console.log(elements);
    // this.valid = elements.length <= 0;
    // if (elements.length > 0) {
      
    //   setTimeout(function() {
        
    //     for(var i = 0; i < elements.length; i++){
    //       console.log(i);
    //       console.log(elements[i].offsetHeight);
    //       if (elements[i].offsetParent != null) {
    //         console.log(i);
    //         elements[i].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    //       }
    //     }
        
    //   }, 
    //   1000);
    // }


    
  }

  notSaved() {
    if (!this.valid) {
      this.validate();
    }
    this.saved = false;
  }

  // Navigation
  nextPage() {
    if (this.saved) {
      this.scrollToTop();
      this.next.emit('next');
    } else {
      // this.eventsManager.notSavedPopUp();
      if (!this.eventsManager.submitted) {
        this.save(false);
      }
      this.next.emit('next');
    }
  }

  prevPage() {
    if (this.saved) {
      this.scrollToTop();
      this.back.emit('back');
    } else {
      // this.eventsManager.notSavedPopUp();
      if (!this.eventsManager.submitted) {
        this.save(false);
      }
      
      this.back.emit('back');
    }
  }

  // Scrolling
  abstract scrollToTop() : void;
  /* {
    window.scroll(0, 0);
    this.document.body.getElementsByClassName('scroll_businessDets')[0].scrollTop = 0;
  } */

  abstract scrollToSave() : void;
  /* {
    document.getElementsByClassName('scroll_businessDets')[0].scrollTop = document.getElementById('save_businessDets').offsetTop;
  } */
  
  
  // Form (select) manipulation

  // Before submit, clean up backend data
  abstract cleanUpData() : Promise<Object>[]; 
}